/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type FeeCode = typeof FeeCode[keyof typeof FeeCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeeCode = {
  APPLICATION_FEE: 'APPLICATION_FEE',
  PROCESSING_FEE: 'PROCESSING_FEE',
  COMMISSION_FEE: 'COMMISSION_FEE',
  COMMITMENT_FEE: 'COMMITMENT_FEE',
  INSURANCE_FEE: 'INSURANCE_FEE',
  LEGAL_FEE: 'LEGAL_FEE',
  APPRAISAL_FEE: 'APPRAISAL_FEE',
  LOAN_TAKEOVER_FEE: 'LOAN_TAKEOVER_FEE',
  EARLY_REPAYMENT_FEE: 'EARLY_REPAYMENT_FEE',
  CUSTOM_1: 'CUSTOM_1',
  CUSTOM_2: 'CUSTOM_2',
  CUSTOM_3: 'CUSTOM_3',
  CUSTOM_4: 'CUSTOM_4',
} as const;
